declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export const sendGenerateLeadEvent = (metadata?: Record<string, any>) => {
  if (typeof window === "undefined" || !window.gtag) return;

  window.gtag("event", "generate_lead", {
    event_category: "engagement",
    event_label: "lets_connect_submit",
    ...metadata,
  });
};

